import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import { translate } from "app/filters/i18nFilter";
import {
    PREPARING_HELP_TEXT,
    PREPARING_MAIN_TEXT,
} from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/main.texts";
import { AssetsService } from "app/services/AssetsService";

import { StyledHelpText, StyledMainText, StyledPreparingContainer } from "./styles";

export const PreparingCsv = () => (
    <StyledPreparingContainer>
        <DotLottieReact
            src={AssetsService.assetUrl("/images/sales-intelligence/enrichingAnimation.lottie")}
            autoplay
            loop
            style={{ width: "300px", height: "250px" }}
        />

        <StyledMainText>{translate(PREPARING_MAIN_TEXT)}</StyledMainText>
        <StyledHelpText>{translate(PREPARING_HELP_TEXT)}</StyledHelpText>
    </StyledPreparingContainer>
);
